import React from "react";
import { FormGroup, Modal, ModalHeader, ModalFooter } from "reactstrap";
import moment from "moment";
import { validateDateForTask } from "./validateDateForTask";
import SpinnerButton from "../Button";

function ConfirmModal({ toggle, handleSubmitArea, dataAlert }) {
  let msg = "";
  if (dataAlert.frecuency === 1) {
    const isAfter = validateDateForTask(dataAlert.formik.values.dueDate);
    if (isAfter) {
      msg = "Los cambios realizados en la Alerta impactarán en la calendarización de el MES CORRIENTE. Desea confirmar los cambios?";
    } else {
      msg = "Los cambios realizados en la Alerta impactarán en la calendarización del PROXIMO MES. Desea confirmar los cambios?";
    }
  }
  if (dataAlert.frecuency === 2) {
    const fecha = moment().date(dataAlert.formik.values.entrega).format("YYYY-MM-DD");
    const isAfter = validateDateForTask(fecha);
    if (isAfter) {
      msg = "Los cambios realizados en la Alerta impactarán en la calendarización de el MES CORRIENTE. Desea confirmar los cambios?";
    } else {
      msg = "Los cambios realizados en la Alerta impactarán en la calendarización del PROXIMO MES. Desea confirmar los cambios?";
    }
  }
  if (dataAlert.formik.values.id !== null) {
    msg = "Los cambios realizados en la Alerta impactarán en la calendarización del PROXIMO MES. Desea confirmar los cambios?";
  }
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <FormGroup>
        <ModalHeader className="text-center" toggle={toggle}>
          {msg}
        </ModalHeader>
        <ModalFooter>
          <div className="mb-0 px-3 w-100 d-flex justify-content-between">
            <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <SpinnerButton className="btn btn-primary" type="button" onClick={handleSubmitArea}>
              Confirmar
            </SpinnerButton>
          </div>
        </ModalFooter>
      </FormGroup>
    </Modal>
  );
}

export default ConfirmModal;
